import Core from "@/modules/core/service/Core";

const url = {
    history     : "/api/audit/unit/{0}/history?type={1}",
    audit       : "/api/audit/{0}",
    entry       : "/api/audit/{0}/entry",
    rebuild     : "/api/audit/report/{0}?recalculate={1}",
    auditHistory: "/api/audit/{0}/entry/history",
}
export default {
    history (unit, type) {
        return Core.method.get(url.history, unit.id, type);
    },

    findById (auditId) {
        return Core.method.get(url.audit, auditId);
    },

    recalculate (auditId) {
        return Core.method.putVoid(url.audit, null, auditId);
    },

    save (auditId, entry) {
        return Core.method.put(url.entry, entry, auditId) ;
    },

    report (component, reportId, auditId, reportName) {
        Core.transfer.load("/api/audit/report/" + reportId + "/" + auditId, ((blob) => {
            const link = document.createElement("a");
            link.href =blob;
            link.download = reportName;
            link.click();
        }), () => {
        });
   },

    rebuildReports (auditId, recalculate) {
        return Core.method.putVoid(url.rebuild, null, auditId, recalculate);
    },

    finAuditHistory (audit) {
        return Core.method.get(url.auditHistory, audit.id);
    }
}